module.exports = __webpack_public_path__ + "img/informe-de-gobierno.e1cb038c.jpg";